module.exports = __webpack_public_path__ + "img/85.4.NH3-N.e093fd92.png";